// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"64":"chunk-common","99":"chunk-mapbox-gl","998":"chunk-vendors"}[chunkId] || chunkId) + ".js";
};